import { z } from 'zod'
import {
    EntityListWithPaginationFields,
    EntityPaginationFields,
    EntityWithIdAndDescriptionFields,
    EntityWithIdFields
} from './baseEntities'

export const schemaEntityWithId = z.object({
    [EntityWithIdFields.Id]: z.number()
})

export const schemaEntityWithIdAndDescription = z
    .object({
        [EntityWithIdAndDescriptionFields.Description]: z.string()
    })
    .merge(schemaEntityWithId)

export const schemaEntityPagination = z.object({
    [EntityPaginationFields.ActualPage]: z.number(),
    [EntityPaginationFields.CantPages]: z.number(),
    [EntityPaginationFields.CantRecords]: z.number(),
    [EntityPaginationFields.PageSize]: z.number()
})

export const schemaEntityListWithPagination = <T extends z.ZodTypeAny>(schema: T) =>
    z.object({
        [EntityListWithPaginationFields.List]: z.array(schema),
        [EntityListWithPaginationFields.Pagination]: schemaEntityPagination
    })

type EntityListWithPaginationType<T extends z.ZodType> = ReturnType<typeof schemaEntityListWithPagination<T>> // no exportar

type EntityListWithPagination<TItems> = z.infer<EntityListWithPaginationType<z.ZodType<TItems>>>

// TODO: Add pagination, base response, etc

type EntityWithId = z.infer<typeof schemaEntityWithId>

type EntityWithIdAndDescription = z.infer<typeof schemaEntityWithIdAndDescription>
